import React, { Component } from 'react';
import autoBind from 'react-autobind';
import '../../styles/inputField.css';
import '../../styles/railSeoSprite.css';
import PropTypes from 'prop-types';

export default class InputField extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      value: this.props.value,
      validations: this.props.validations,
      error: this.props.error,
      type: this.props.type,
      loading: false,
      disabled: false,
      showValidations: false,
      valueEntered: false,
      shouldShowError: true // be ready to show any error if present
      //   loading: this.props.loading,
    };
  }

  updateValue(value) {
    this.setState({ value: value });
    const { updateParentValue } = this.props;
    updateParentValue && updateParentValue(value);
  }

  handleFocusIn() {
    // stop showing error in input field when editing
    this.setState({ showValidations: true, shouldShowError: false });
  }

  handleFocusOut() {
    // start showing error if any when finished editing
    this.setState({ showValidations: false, shouldShowError: true });
    const { onFocusOutProps } = this.props;
    onFocusOutProps && onFocusOutProps(this.state.value); // check error by making some expensive api call on focus out, show error if any
  }

  handleInput(event) {
    const { validations } = this.state;
    const value = event.target.value;
    this.updateValue(value);
    if (value) {
      this.setState({ valueEntered: true });
    } else {
      this.setState({ valueEntered: false });
    }
    if (!validations) {
      return;
    } else {
      const validationsWithStatus = validations.map((item) => ({
        ...item,
        validated: item.regex.test(value)
      }));
      this.setState({ validations: validationsWithStatus });
    }
  }

  togglePasswordVisibility() {
    const fieldType = this.state.type === 'password' ? 'text' : 'password';
    this.setState({ type: fieldType });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error) {
      this.setState({ error: this.props.error });
    }
  }

  render() {
    const {
      placeholder,
      errorMsg,
      link,
      hintText,
      label,
      prefixCode,
      eyeIcon,
      mobNum,
      className,
      customClass,
      maxLength
    } = this.props;
    const { error, type, validations, showValidations, valueEntered, loading, value, shouldShowError } = this.state;
    const errorContainerStyle = shouldShowError && error;
    const errorExists = shouldShowError && error && errorMsg;
    return (
      <div
        className={`makeFlex column inputFieldContainer ${mobNum ? 'mobContainer' : ''}
        ${errorContainerStyle ? 'appendBottom15' : ''} ${customClass} ${errorContainerStyle ? 'errorField' : ''}`}
      >
        {mobNum && <span className="mobPrefix">+91</span>}
        {label && <label className="latoBold appendBottom10 font14 defaultGreyText">{label}</label>}
        {prefixCode && <span className="font14 lightGreyText prefixedCode">{prefixCode}</span>}
        {valueEntered && eyeIcon && (
          <a
            href="javascript:void(0);"
            className="railSeoSprite eyeIcon eyeIconContainer"
            onClick={this.togglePasswordVisibility}
          />
        )}
        {loading && <span className="blueLoader" />}
        <input
          value={value}
          type={type}
          placeholder={placeholder}
          className={`inputField ${prefixCode ? 'prefixed' : ''} ${className}`}
          onFocus={this.handleFocusIn}
          onChange={this.handleInput}
          disabled={loading}
          maxLength={maxLength}
          onBlur={this.handleFocusOut}
        />
        {hintText && <span className="appendTop10 font12 defaultGreyText">{hintText}</span>}
        {errorExists && <span className="font12 errorText">{errorMsg}</span>}
        {link && (
          <span className="latoBold appendTop15 font14">
            <a href="javascript:void(0);">{link}</a>
          </span>
        )}
        {validations && validations.length && showValidations && (
          <ol className="formValidations">
            {validations.map((item) => {
              return (
                <li className="makeFlex hrtlCenter appendBottom10" key={item.key}>
                  <span className={`tickIcon appendRight10 ${item.validated ? 'validated' : ''}`} />
                  <span className="lightGreyText font14">{item.text}</span>
                </li>
              );
            })}
          </ol>
        )}
      </div>
    );
  }
}

InputField.propTypes = {
  validations: PropTypes.array,
  value: PropTypes.string,
  updateParentValue: PropTypes.func,
  error: PropTypes.bool,
  errorMsg: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  hintText: PropTypes.string,
  prefixCode: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  customClass: PropTypes.string,
  link: PropTypes.string,
  eyeIcon: PropTypes.bool,
  mobNum: PropTypes.string,
  maxLength: PropTypes.number,
  onFocusOutProps: PropTypes.func
};
